/** @flow */
import React from "react";
import "./title-section.style.scss";

type TitleSectionProps = $Exact<{
  title: string | React$Node,
  rightLink?: string | React$Node,
  path?: Array<{
    path: string,
    title: string,
  }>,
  bottomSection?: string | React$Node,
  titleClassName?: string,
  rightLinkClassName?: string,
  containerClassName?: string,
  rowClassName?: string,
}>;

export const TitleSection = (props: TitleSectionProps) => (
  <div className={`title-section-container py-4 ${props.containerClassName || ""}`}>
    <div
      className={`title d-flex align-items-center justify-content-between ${props.rowClassName ||
        ""}`}
    >
      <h4 className={`heading ${props.titleClassName || ""}`}>{props.title}</h4>
      {props.rightLink && <div className={props.rightLinkClassName}>{props.rightLink}</div>}
    </div>
    {props.bottomSection ? props.bottomSection : null}
  </div>
);

export default TitleSection;
